<template>
  <div class="container-fluid mt-3">
    <div class="row">
      <div class="col-12 px-0">
        <div v-if="success" class="mt-4">
          <programa-tab :call="call">
            <div slot="footer">
              <div class="card-footer text-center">
                <argon-alert type="success" class="mb-0"
                  >Inscrição realizada com sucesso!</argon-alert
                >
              </div>
            </div>
          </programa-tab>
        </div>
        <div class="text-center col-10 mx-auto" v-else-if="error">
          <argon-alert color="danger"
            >Ocorreu um erro ao recuperar as informações. Por favor, verifique o
            endereço informado e tente novamente.</argon-alert
          >
        </div>
        <form-wizard
          :color="$store.state.auth.secondary_color"
          :errorColor="
            $store.getters.brightColor({
              color: $store.state.auth.secondary_color,
              gradient: -50,
            })
          "
          class="container"
          v-else
        >
          <template slot="title">
            <div class="col-12">
              <h3 class="text-light font-weight-normal">
                Chamada Pública OLIMPÍADA DE INOVAÇÃO do Instituto Federal de
                Educação, Ciência e Tecnologia
              </h3>
            </div>
          </template>
          <!-- Programa -->
          <tab-content title="Programa" icon="ni ni-planet">
            <div class="vld-parent" ref="programa_container">
              <programa-tab :call="call" />
            </div>
          </tab-content>
          <tab-content title="Ficha de Inscrição" icon="fas fa-clipboard-list">
            <div class="card card-profile shadow">
              <div class="card-header">
                <div class="row align-items-center">
                  <div class="col-12">
                    <h4 class="mb-0">
                      FORMULÁRIO DE INSCRIÇÃO DA OLIMPÍADA DE INOVAÇÃO
                    </h4>
                  </div>
                </div>
              </div>
              <div class="card-body mt-2 py-3">
                <div class="row">
                  <div class="col-12 mb-3">
                    <h6 class="heading-small text-muted">Equipe</h6>
                  </div>
                </div>
                <div class="row ml-lg-2">
                  <div class="col-lg-6">
                    <argon-input
                      label="Nome da equipe*"
                      v-model="model.equipe_nome"
                      placeholder="Nome da equipe"
                    />
                    <p class="description mt--3 ml-1 text-sm">
                      Atenção: o nome não pode indicar de forma alguma o campus
                      da equipe.
                    </p>
                  </div>
                  <div class="col-lg-6">
                    <!--
                    <argon-input
                      label="Campus da equipe*"
                      v-model="model.equipe_campus"
                      placeholder="Nome do campus"
                    />
                    -->

                    <argon-input
                      label="Campus da equipe*"
                      v-model="model.equipe_campus"
                      placeholder="Nome do Campus ex: Governador Valadares"
                    >
                    </argon-input>
                  </div>
                  <div class="col-lg-6">
                    <argon-input
                      label="Email da equipe*"
                      v-model="model.equipe_email"
                      placeholder="example@email.com"
                    />
                  </div>
                  <div class="col-lg-12">
                    <estados
                      estadoLabel="Estado da equipe*"
                      labelClasses="estado-font"
                      selectClasses="form-select-md"
                      cidadeLabel="Cidade da equipe*"
                      :selectedEstado="model.equipe_estado"
                      :selectedCidade="model.equipe_cidade"
                      @inputEstado="model.equipe_estado = $event"
                      @inputCidade="model.equipe_cidade = $event"
                    />
                  </div>
                </div>
                <hr class="mt-3 mb-4" />
                <div class="row">
                  <div class="col-12 mb-3">
                    <h6 class="heading-small text-muted">Orientador(a)</h6>
                  </div>
                </div>
                <div class="row ml-lg-2">
                  <div class="col-lg-6">
                    <!--<argon-input
                      label="Campus do orientador*"
                      v-model="model.orientador_campus"
                      placeholder="Nome do campus"
                    />-->

                    <argon-input
                      label="Campus do orientador*"
                      v-model="model.orientador_campus"
                      placeholder="Nome do Campus ex: Governador Valadares"
                    >
                    </argon-input>
                  </div>
                  <div class="col-lg-6">
                    <argon-input
                      label="Nome completo do orientador*"
                      v-model="model.orientador_nome"
                      placeholder="Nome completo do orientador"
                    />
                  </div>
                  <div class="col-lg-6">
                    <argon-input
                      addonLeftIcon="fab fa-whatsapp"
                      v-model="model.orientador_telefone"
                      placeholder="Telefone celular do orientador"
                      label="Telefone (com DDD) do orientador*"
                      mask="['(##) ####-####', '(##) #####-####']"
                    >
                    </argon-input>
                  </div>
                  <div class="col-lg-6">
                    <argon-input
                      label="Email do orientador*"
                      addon-left-icon="ni ni-email-83"
                      v-model="model.orientador_email"
                      placeholder="Email do orientador"
                    />
                  </div>
                </div>
                <hr class="mt-3 mb-4" />
                <div class="row">
                  <div class="col-12 mb-3">
                    <h6 class="heading-small text-muted">
                      Co-orientador(a) - Opcional
                    </h6>
                  </div>
                </div>
                <div class="row ml-lg-2">
                  <div class="col-lg-6">
                    <!--
                    <argon-input
                      label="Campus do co-orientador"
                      v-model="model.coorientador_campus"
                      placeholder="Nome do campus"
                    />
                    -->
                    <argon-input
                      label="Campus do co-orientador*"
                      v-model="model.coorientador_campus"
                      placeholder="Nome do Campus ex: Governador Valadares"
                    >
                    </argon-input>
                  </div>
                  <div class="col-lg-6">
                    <argon-input
                      label="Nome completo do co-orientador"
                      v-model="model.coorientador_nome"
                      placeholder="Nome completo do co-orientador"
                    />
                  </div>
                  <div class="col-lg-6">
                    <label class="form-control-label d-block mb-2"></label>
                    <argon-input
                      v-model="model.coorientador_telefone"
                      addonLeftIcon="fab fa-whatsapp"
                      placeholder="Telefone do co-orientador"
                      type="tel"
                      label="Telefone (com DDD) do co-orientador"
                      mask="['(##) ####-####', '(##) #####-####']"
                    >
                    </argon-input>
                  </div>
                  <div class="col-lg-6">
                    <argon-input
                      addon-left-icon="ni ni-email-83"
                      label="Email do co-orientador"
                      v-model="model.coorientador_email"
                      placeholder="Email do co-orientador"
                    />
                  </div>
                </div>
                <hr class="mt-3 mb-4" />
                <div class="row">
                  <div class="col-12 mb-3">
                    <h6 class="heading-small text-muted">Membros da equipe</h6>
                  </div>
                  <div class="col-12">
                    <p class="ml-lg-2">
                      A equipe pode conter de 3 (três) a 6 (seis) membros. O 1º
                      membro será considerado como a indicação do representante
                      da equipe. Preencha abaixo as informações de cada membro.
                    </p>
                  </div>
                </div>
                <div v-for="index in NUM_MEMBROS" :key="index">
                  <hr class="mt-2 mb-4" />
                  <div class="row">
                    <div class="col-12 mb-3">
                      <h6 class="heading-small text-muted">
                        {{ index }}º membro
                        <span v-if="index === 1"
                          >(representante da equipe)</span
                        >
                      </h6>
                    </div>
                  </div>
                  <div class="row ml-lg-2">
                    <div class="col-lg-6">
                      <argon-input
                        label="Nome do membro"
                        v-model="model.membros[index - 1].nome"
                        placeholder="Nome completo do membro"
                      />
                    </div>
                    <div class="col-lg-6">
                      <argon-input
                        label="Curso matriculado pelo aluno ou formado pelo ex-aluno"
                        v-model="model.membros[index - 1].curso"
                        placeholder="Curso do membro"
                      />
                    </div>
                    <div class="col-lg-6">
                      <argon-input
                        label="Data de nascimento"
                        type="date"
                        v-model="model.membros[index - 1].nascimento"
                        placeholder="Data de nascimento"
                      />
                    </div>
                    <div class="col-lg-6">
                      <argon-input
                        label="CPF do membro"
                        v-model="model.membros[index - 1].cpf"
                        type="tel"
                        placeholder="CPF do membro"
                        mask="###.###.###-##"
                      >
                      </argon-input>
                    </div>
                    <div class="col-lg-6">
                      <argon-input
                        label="RG do membro"
                        mask="#######"
                        v-model="model.membros[index - 1].rg"
                        placeholder="Número do RG"
                      />
                    </div>
                    <div class="col-lg-6">
                      <argon-input
                        label="Órgão emissor do RG"
                        v-model="model.membros[index - 1].orgao_emissor"
                        placeholder="Órgão emissor"
                      />
                    </div>
                    <div class="col-lg-6">
                      <label class="form-control-label d-block mb-2"
                        >Telefone (com DDD) do membro</label
                      >
                      <argon-input
                        addonLeftIcon="fab fa-whatsapp"
                        mask="['(##) ####-####', '(##) #####-####']"
                        v-model="model.membros[index - 1].telefone"
                        type="tel"
                        placeholder="Telefone celular do membro"
                      >
                      </argon-input>
                    </div>
                    <div class="col-lg-6">
                      <argon-input
                        addon-left-icon="ni ni-email-83"
                        label="Email do membro"
                        v-model="model.membros[index - 1].email"
                        placeholder="Email do membro"
                      />
                    </div>
                    <div class="col-lg-6">
                      <p class="text-muted description mb-1 text-sm">
                        <i class="far fa-file-pdf mr-2"></i>
                        <b class="ms-1 font-weight-bold"
                          >Comprovante de matrícula</b
                        >
                        ou
                        <b class="font-weight-bold"
                          >declaração de conclusão do curso</b
                        >
                        (arquivo <b class="font-weight-bold">PDF</b> com
                        <b class="font-weight-bold">tamanho máximo de 5mb</b>).
                      </p>
                      <file-select
                        v-model="model.membros[index - 1].comprovante"
                        title="Selecione o arquivo"
                        accept="application/pdf"
                        type="primary"
                        :mbSize="5"
                      >
                      </file-select>
                    </div>
                    <div
                      class="col-lg-6"
                      v-if="memberIsAMinor(model.membros[index - 1].nascimento)"
                    >
                      <p class="text-muted description mb-1 text-sm">
                        <i class="far fa-file-pdf mr-2"></i>
                        <b class="ms-1 font-weight-bold"
                          >Termo de autorização dos pais ou responsáveis
                          legais</b
                        >, conforme o modelo em Anexo I (arquivo
                        <b class="font-weight-bold">PDF</b> com
                        <b class="font-weight-bold">tamanho máximo de 5mb</b>).
                      </p>
                      <file-select
                        v-model="model.membros[index - 1].termo"
                        title="Selecione o arquivo"
                        accept="application/pdf"
                        type="primary"
                        :mbSize="5"
                      >
                      </file-select>
                    </div>
                  </div>
                </div>
                <div class="text-center mt-4" v-if="errors.fieldError.show">
                  <argon-alert color="danger">{{
                    errors.fieldError.text
                  }}</argon-alert>
                </div>
                <div
                  class="text-center mt-4 error"
                  v-else-if="errors.submitError.show"
                >
                  <argon-alert type="danger">{{
                    errors.submitError.text
                  }}</argon-alert>
                </div>
              </div>
            </div>
          </tab-content>
          <template #footer="props">
            <div class="wizard-footer-left">
              <argon-button
                v-if="props.activeTabIndex > 0"
                @click.native="props.prevTab()"
                :style="props.fillButtonStyle"
              >
                Voltar</argon-button
              >
            </div>
            <div class="wizard-footer-right">
              <argon-button
                v-if="!props.isLastStep"
                @click.native="props.nextTab()"
                class="wizard-footer-right"
                :style="props.fillButtonStyle"
                >Avançar
              </argon-button>
              <argon-button
                v-else
                @click.native="onComplete()"
                class="wizard-footer-right finish-button"
                :style="props.fillButtonStyle"
                >Concluir inscrição</argon-button
              >
            </div>
          </template>
        </form-wizard>
        <modal
          :show.sync="modals.confirmation"
          modal-classes="modal-dialog-centered"
          body-classes="py-0"
        >
          <template #header>
            <h4 slot="header" class="modal-title" id="modal-title-notification">
              Atenção!
            </h4>
          </template>
          <div class="vld-parent" ref="modal_confirmation">
            <div class="text-center">
              <i class="fas fa-exclamation fa-3x"></i>
              <h3 class="mt-2">Declaração de Responsabilidade</h3>
              <p class="description">
                Ao prosseguir, você declara conhecimento e integral concordância
                com as normas e com as condições estabelecidas na Chamada
                Pública {{ monthPlusYear }} para Seleção de Propostas da IV
                OLIMPÍADA DE INOVAÇÃO - e assume serem verdadeiras as
                informações constantes no formulário de inscrição apresentado,
                isentando o de quaisquer responsabilidades, quais sejam, civis
                ou penais.
              </p>
              <p class="mt-3">
                Você realmente deseja concluir sua inscrição na chamada
                <span class="font-weight-bold">{{ call.name }}</span
                >?
              </p>
            </div>
          </div>
          <template #footer>
            <argon-button
              type="link"
              color="gray-400"
              class="ml-auto"
              @click="modals.confirmation = false"
            >
              Voltar
            </argon-button>
            <argon-button
              type="white"
              color="success"
              variant="gradient"
              @click="handleSubmit"
              :disabled="modals.disabledSubmit"
            >
              Confirmar inscrição
            </argon-button>
          </template>
        </modal>
      </div>
    </div>
  </div>
</template>
<script>
import { FormWizard, TabContent, WizardButton } from "vue3-form-wizard";
import "vue3-form-wizard/dist/style.css";
import { FORMCALLSO} from "@/store/cacheConstants";
import Estados from "@/components/Estados.vue";
import ProgramaTab from "./ProgramaTab";
import store from "@/store/index.js";
import api from "@/services/api.js";

export default {
  name: "inscricao",
  components: {
    Estados,
    ProgramaTab,
    FormWizard,
    TabContent,
    WizardButton,
  },
  data() {
    return {
      call: {
        name: "",
        status: "",
        link: "",
        type: "",
        region: "",
        region_limited: false,
        start_date: "",
        end_date: "",
        max_startups: "",
        sectors: "",
        description: "",
        observation: "",
      },
      model: {
        equipe_nome: "",
        equipe_campus: "",
        equipe_estado: "",
        equipe_cidade: "",
        equipe_email: "",
        orientador_campus: "",
        orientador_nome: "",
        orientador_telefone: "",
        orientador_email: "",
        coorientador_campus: "",
        coorientador_nome: "",
        coorientador_telefone: "",
        coorientador_email: "",
        membros: [{ nome: "", curso: "", nascimento: "", cpf: "", rg: "", orgao_emissor: "", telefone: "", email: "", comprovante: null, termo: null }, { nome: "", curso: "", nascimento: "", cpf: "", rg: "", orgao_emissor: "", telefone: "", email: "", comprovante: null, termo: null }, { nome: "", curso: "", nascimento: "", cpf: "", rg: "", orgao_emissor: "", telefone: "", email: "", comprovante: null, termo: null }, { nome: "", curso: "", nascimento: "", cpf: "", rg: "", orgao_emissor: "", telefone: "", email: "", comprovante: null, termo: null }, { nome: "", curso: "", nascimento: "", cpf: "", rg: "", orgao_emissor: "", telefone: "", email: "", comprovante: null, termo: null }],
      },
      optionalFields: [
        "coorientador_campus",
        "coorientador_nome",
        "coorientador_telefone",
        "coorientador_email",
      ],
      errors: {
        fieldError: {
          show: false,
          text:
            "Por favor, preencha todos os campos solicitados antes de continuar.",
        },
        submitError: {
          show: false,
          text:
            "Ocorreu um erro ao realizar a inscrição. Verifique os dados e tente novamente.",
        },
      },
      editorEdittable: {
        placeholder: "Escreva aqui...",
      },
      modals: {
        confirmation: false,
        disabledSubmit: false,
      },
      success: false,
      error: false,
      NUM_MEMBROS: 5,
      campisList: [
        "Arcos",
        "Bambuí",
        "Betim",
        "Congonhas",
        "Conselheiro Lafaiete",
        "Formiga",
        "Governador Valadares",
        "Ibirité",
        "Ipatinga",
        "Itabirito",
        "Ouro Branco",
        "Ouro Preto",
        "Piumhi",
        "Ponte Nova",
        "Ribeirão das Neves",
        "Sabará",
        "Santa Luzia",
        "São João Evangelista",
      ],
    };
  },
  

  async mounted() {
    let loader = this.$loading.show({
      container: this.$refs.programa_container,
      width: 140,
      height: 140,
      opacity: 1,
    });
    try {
      const { data } = await api.get(
        `public/startup-calls/${this.$route.params.slug}`
      );
      if (data.sectors) data.sectors = data.sectors.split(";").filter((s) => s);
      Object.assign(this.call, data);
      this.model = JSON.parse(localStorage.getItem(FORMCALLSO))  || this.model;
      if (Array.isArray(this.model.membros)) {
            this.model.membros.forEach(membro => {
                membro.termo = null;
                membro.comprovante = null;
            });
        }
    } catch (e) {
      this.$error.errorMessageToast(
        "Ocorreu um erro ao recuperar as informações",
        e
      );
      this.error = true;
    } finally {
      loader.hide();
    }
  },
  methods: {
    memberIsAMinor(birthday) {
      birthday = new Date(birthday);
      const currentDate = new Date();
      let age = currentDate.getFullYear() - birthday.getFullYear();
      let m = currentDate.getMonth() - birthday.getMonth();
      if (m < 0 || (m === 0 && currentDate.getDate() < birthday.getDate()))
        age--;
      return !age || age < 18;
    },
    async handleSubmit() {
      this.modals.disabledSubmit = true;
      this.errors.submitError.show = this.errors.fieldError.show = false;
      const loader = this.$loading.show({
        container: this.$refs.modal_confirmation,
        opacity: 0,
        width: 140,
        height: 140,
      });
      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      const data = new FormData();

      for (let membroCount = 0; membroCount < this.NUM_MEMBROS; membroCount++) {
        if (this.model.membros[membroCount].nome) {
          data.append(
            `comprovante_${membroCount}`,
            this.model.membros[membroCount].comprovante,
            this.model.membros[membroCount].comprovante.name
          );
          if (this.model.membros[membroCount].termo) {
            data.append(
              `termo_${membroCount}`,
              this.model.membros[membroCount].termo,
              this.model.membros[membroCount].termo.name
            );
          }
        }
      }
      data.append("subscription", JSON.stringify(this.model));
      try {
        await api.request({
          timeout: 60000,
          method: "post",
          url: `public/olimpiada/startup-calls/${this.$route.params.slug}/subscriptions`,
          data,
          config
      });
        this.$toast.info("Inscrição realizada com sucesso!");
        this.modals.confirmation = false;
        this.success = true;
        store.commit("dropFormCalls", FORMCALLSO);
      } catch (e) {
        this.$error.errorMessageToast(
          "Ocorreu um erro ao realizar a inscrição",
          e
        );
        this.errors.submitError.show = true;
        this.modals.confirmation = false;
      } finally {
        loader.hide();
        this.modals.disabledSubmit = false;
      }
    },
    onComplete: function () {
      if (this.isValidModel()) {
        this.modals.confirmation = true;
      }
    },
    isValidModel() {
      this.errors.fieldError.show = false;
      const model = this.model;
      const optionalFields = this.optionalFields;
      for (const [key, value] of Object.entries(model)) {
        if (!optionalFields.includes(key)) {
          if (value === "" || value === null) {
            this.errors.fieldError.show = true;
            return false;
          }
        }
      }
      for (const membro of model.membros) {
        for (const [key, value] of Object.entries(membro)) {
          if (membro.nome !== "" && (value === "" || value === null)) {
            if (key === "termo" && this.memberIsAMinor(membro.nascimento)) {
              this.errors.fieldError.show = true;
            } else if (key !== "termo") {
              this.errors.fieldError.show = true;
              return false;
            }
          }
        }
      }
      return true;
    },
    addmembros() {
      for (let i = 0; i < this.NUM_MEMBROS; i++) {
        this.model.membros.push({
          nome: "",
          curso: "",
          nascimento: "",
          cpf: "",
          rg: "",
          orgao_emissor: "",
          telefone: "",
          email: "",
          comprovante: null,
          termo: null,
        });
      }
    },
  },
  computed: {
    monthPlusYear() {
      const date = new Date(this.call.end_date);
      return (
        String(date.getMonth() + 1).padStart(2, "0") +
        "/" +
        String(date.getFullYear())
      );
    },
  },
  watch: {  
    model: {
      handler: function () {
        const currentModel = JSON.stringify(this.model); 
        const defaultModel = JSON.stringify(this.$options.data().model); 
        if (!(currentModel === defaultModel)) store.commit("storeFormCalls", { key: FORMCALLSO, data: JSON.stringify(this.model) }); 
      },
      deep: true,
    }
  }
};
</script>
<style scoped>
.cursor-pointer {
  cursor: pointer;
}

.estado-font {
  font-size: 15px;
}

.finish-button {
  background-color: #43a047 !important;
  border-color: #43a047 !important;
}

.finish-button:hover,
.finish-button:focus,
.finish-button:active {
  background-color: #1e8623 !important;
  border-color: #1e8623 !important;
}

.vue3-form-wizard .wizard-btn {
  padding: 9px 12px;
}
</style>
<style>
.vue3-form-wizard .wizard-nav-pills > li > a span.stepTitle:not(.active) {
  color: #bbbbbb !important;
}

.vue3-form-wizard > .wizard-navigation > .wizard-tab-content {
  padding: 30px 0px 10px !important;
}

.vue3-form-wizard > .wizard-card-footer {
  padding: 0 !important;
}

.of-container-edditable .quill-editor .ql-container,
.of-container-edditable .quill-editor .ql-container .ql-editor {
  min-height: 11rem;
  width: 100%;
}

p > strong {
  font-weight: bold !important;
}
</style>
